import { type FC, type ReactNode, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { dimmed, pulsing } from './style'

export const NotAvailable: FC = () => {
  const { t } = useTranslation('shared')
  return <span className={dimmed}>{t('common.label.not-available-short', 'N/A')}</span>
}

export const Loading: FC = () => {
  const { t } = useTranslation('shared')
  return <span className={pulsing}>{t('common.label.loading', 'Loading...')}</span>
}

const zeroWidthSpace = '\u200B'

export const BreakAtDividers: FC<{ children: string | undefined }> = ({ children }) => {
  // keep divider, add a zero-width space before and after it
  return useMemo(() => {
    if (!children) {
      return <NotAvailable />
    }

    const regex = /([.\-:;,])/g
    return children.replace(regex, `${zeroWidthSpace}$1${zeroWidthSpace}`)
  }, [children])
}

export const CombinedEntries: FC<{
  primary: ReactNode
  secondary?: ReactNode
}> = ({ primary, secondary }) => {
  return (
    <>
      {primary ? <span>{primary}</span> : <NotAvailable />}
      {secondary && <span className={dimmed}>{secondary}</span>}
    </>
  )
}
